module.exports = __webpack_public_path__ + "static/img/login_bg.fc08627.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_bg.png
// module id = 1/O3
// module chunks = 66